import { GetPaymentUrlRequest } from '../../models/MID/requests/GetPaymentUrlRequest'
import type PaymentMethods from '../../models/MID/PaymentMethods'

export default class GetPaymentURLMapper {
  static toRequest(
    quotationId: string,
    paymentMethod: PaymentMethods,
    urlReturnPath = '/retorno-pago'
  ): GetPaymentUrlRequest {
    let pathname = window.location.pathname
    if (pathname.endsWith('/') && urlReturnPath.startsWith('/')) {
      pathname = pathname.substring(0, pathname.length - 1)
    }
    return new GetPaymentUrlRequest({
      quotationId,
      urlReturn: window.location.origin + pathname + urlReturnPath,
      paymentMethod
    })
  }
}
